import React from "react";

export const FieldRadio = (props, ref) => {
  const {
    label,
    error,
    helperText,
    leftElement,
    rightElement,
    registration,
    id,
    ...restProps
  } = props;
  const hasLabel = !!label;
  const isInvalid = !!props.error;

  const inputProps = {
    ref: ref,
    id: id,
    ...restProps,
    ...registration,
  };

  const InputImpl = (
    <input
      type="radio"
      className="flex-none accent-primary-black"
      {...inputProps}
    />
  );

  return (
    <div
      className={`
      ${props.type === "hidden" ? "none" : "flex gap-1 items-center"}
      ${props.isDisabled ? "cursor-not-allowed" : ""}
      `}
    >
      {hasLabel ? (
        <>
          {InputImpl}
          <label htmlFor={inputProps.id}>{label}</label>
        </>
      ) : (
        <label m={0}>{InputImpl}</label>
      )}

      {!isInvalid && helperText ? <span>{helperText}</span> : null}
      {error ? <span className="text-red">{error.message}</span> : null}
    </div>
  );
};
